import React, { useContext, useEffect, useState } from 'react';
import { UserContext } from '~/dashboard/context';
import { redirectToRuleLibrary } from '~/dashboard/components/Sidebar/useRuleLibrarySession';
import LoadingView from '~/dashboard/views/LoadingView';
import { RULE_LIBRARY_ORGANIZATION_SLUG } from '~/constants';

export const LibraryRouteGuard = ({ children }: { children: JSX.Element }) => {
  const [isLoading, setIsLoading] = useState(true);

  const { customer } = useContext(UserContext);
  const organizationNameSlug = customer?.organizationNameSlug;

  useEffect(() => {
    if (!organizationNameSlug) {
      setIsLoading(true);
      return;
    }

    if (organizationNameSlug === RULE_LIBRARY_ORGANIZATION_SLUG) {
      setIsLoading(false);
      return;
    }

    const nextUrl = `${window.location.pathname}${window.location.search || ''}${window.location.hash || ''}`;
    redirectToRuleLibrary(nextUrl);
  }, [organizationNameSlug]);

  if (isLoading) return <LoadingView />;

  return children;
};
